import { api } from "@/api/axios.ts";
import { ApiAuthorization } from "@/types/employees/employee.types.ts";
import { ApiIntegrationLoginUrl } from "@/types/integrations/integration.types.ts";

export const apiAuth = {
  getGoogleLoginUrl: async function () {
    return api.get<ApiIntegrationLoginUrl>(`/api/v1/employees/login/oauth/google`);
  },

  googleCallback: async function (code: string, state?: string) {
    return api.get<ApiAuthorization>(
      `/api/v1/employees/login/oauth/callback/google?code=${code}&state=${state}`
    );
  },

  getEntraLoginUrl: async function () {
    return api.get<ApiIntegrationLoginUrl>(`/api/v1/employees/login/oauth/entra`);
  },

  entraCallback: async function (code: string, state?: string) {
    return api.get<ApiAuthorization>(
      `/api/v1/employees/login/oauth/callback/entra?code=${code}&state=${state}`
    );
  },

  getOidcLoginUrl: async function (organizationId: number, loginHint: string) {
    return api.get<ApiIntegrationLoginUrl>(`/api/v1/employees/login/oauth/oidc`, {
      organization_id: organizationId,
      login_hint: loginHint,
    });
  },

  oidcCallback: async function (code: string, state?: string) {
    return api.get<ApiAuthorization>(
      `/api/v1/employees/login/oauth/callback/oidc?code=${code}&state=${state}`
    );
  },
};
